import { inject, Injectable } from '@angular/core';
import {
    DatabaseInteractionSearch,
    PlayErrorReportingSearch,
    SalesforceInteractionSearch,
} from '@r1-compass-library/models';
import { PlayDatabaseInteractionService } from './play-database-interaction.service';
import { PlayErrorService } from './play-error.service';
import { PlaySalesforceInteractionService } from './play-salesforce-interaction.service';
import { forkJoin } from 'rxjs';

/**
 * A service for retrieving all play errors and interactions associated with a specific execution.
 */
@Injectable({
    providedIn: 'root',
})
export class PlayExecutionInteractionErrorDataService {
    readonly #playDatabaseInteractionService = inject(PlayDatabaseInteractionService);
    readonly #playErrorService = inject(PlayErrorService);
    readonly #playSalesforceInteractionService = inject(PlaySalesforceInteractionService);

    getErrorsAndInteractions(playResultId: number) {
        const databaseSearch: DatabaseInteractionSearch = {
            playResultId: playResultId,
            fields: [],
            groupByFields: [],
        };
        const processingErrorSearch: PlayErrorReportingSearch = {
            playResultId: playResultId,
            fields: [],
            groupByFields: [],
        };
        const salesforceSearch: SalesforceInteractionSearch = {
            playResultId: playResultId,
            fields: [],
            groupByFields: [],
        };

        return forkJoin({
            databaseInteractions: this.#playDatabaseInteractionService.find(databaseSearch),
            processingErrors: this.#playErrorService.getErrorDetailsForReporting(processingErrorSearch),
            salesforceInteractions: this.#playSalesforceInteractionService.find(salesforceSearch),
        });
    }
}
